import { TimelineTrackingCallbacks } from '@ardoq/timeline2024';
import {
  startViewLoadTracking,
  recordViewModelReady,
  recordRenderComplete,
  DEFAULT_EXPECTED_DURATION,
} from 'tracking/durationTracking/viewPerformance';
import { ViewLoadMetrics } from 'tracking/durationTracking/types';

export const startTimelineTracking = (): string =>
  startViewLoadTracking('Timeline', DEFAULT_EXPECTED_DURATION);

export const getTimelineTrackingCallbacks = (
  trackingId: string,
  metrics: ViewLoadMetrics
): TimelineTrackingCallbacks => ({
  onViewModelReady: () => recordViewModelReady(trackingId, metrics),
  onRendered: () => recordRenderComplete(trackingId),
});
